import { View, ScrollView, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import Head from "expo-router/head";

export default function TermsAndConditions() {
  const { colors } = useTheme();

  return (
    <>
      <Head>
        <title>Terms and Conditions - RockForce App</title>
      </Head>
      <View style={styles.outerContainer}>
        <ScrollView contentContainerStyle={styles.content}>
          <View style={[styles.card, { backgroundColor: colors.card, borderColor: colors.border }]}>
            <ThemedText style={[styles.title, { color: colors.text }]}>Terms and Conditions</ThemedText>
            <ThemedText style={[styles.updated, { color: colors.textSecondary }]}>
              Last Updated: June 5, 2026
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Program Name</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              RockForce Shift Notifications
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Program Description</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              RockForce App is a workforce management platform for payroll, staffing, and operations. By opting in to
              our SMS messaging program, you consent to receive text messages related to shift invitations, scheduling
              updates, and work-related notifications from RockForce.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Message Frequency</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              Message frequency varies based on your shift assignments and scheduling activity. You will receive
              messages when you are invited to work a shift or when there are updates to your scheduled assignments.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Message and Data Rates</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              Message and data rates may apply. RockForce does not charge for SMS messages, but your mobile carrier{"'"}
              s standard messaging and data rates may apply. Please contact your carrier for details about your plan.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Opt-Out Instructions</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              You may opt out of receiving SMS messages at any time. To stop receiving messages, reply{" "}
            </ThemedText>
            <ThemedText style={[styles.bold, { color: colors.text }]}>STOP</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              {" "}
              to any message from RockForce. You will receive a one-time confirmation message and will no longer receive
              SMS notifications. You may re-enroll at any time by texting{" "}
            </ThemedText>
            <ThemedText style={[styles.bold, { color: colors.text }]}>START</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              {" "}
              to our number or opting in through the RockForce app.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Help</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>For support, reply </ThemedText>
            <ThemedText style={[styles.bold, { color: colors.text }]}>HELP</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              {" "}
              to any message from RockForce, or contact us at support@rockforce.com.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Privacy</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              Your privacy is important to us. Your phone number and personal information will not be shared with third
              parties for marketing purposes. For full details, please review our Privacy Policy.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Changes to Terms</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              We reserve the right to update these terms at any time. Changes will be posted on this page with an
              updated effective date. Continued use of the SMS service after changes constitutes acceptance of the
              revised terms.
            </ThemedText>

            <ThemedText style={[styles.sectionTitle, { color: colors.text }]}>Contact Information</ThemedText>
            <ThemedText style={[styles.body, { color: colors.textSecondary }]}>
              RockForce Support{"\n"}
              Email: support@rockforce.com
            </ThemedText>
          </View>
        </ScrollView>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    alignItems: "center",
  },
  content: {
    padding: 20,
    width: "100%",
    maxWidth: 700,
    alignSelf: "center",
  },
  card: {
    borderRadius: 16,
    borderWidth: 1,
    padding: 24,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 4,
  },
  updated: {
    fontSize: 13,
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 17,
    fontWeight: "700",
    marginTop: 24,
    marginBottom: 8,
  },
  body: {
    fontSize: 15,
    lineHeight: 24,
  },
  bold: {
    fontSize: 15,
    lineHeight: 24,
    fontWeight: "800",
  },
});
